import {
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useDisclosure,
  Image,
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
} from '@chakra-ui/icons';

import { UserMenu } from "~/components"
import { useLocation, Link } from '@remix-run/react'

export function NavBarAT() {
  let { isOpen, onToggle } = useDisclosure();
  let location = useLocation();


  return (
    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}>
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}>
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>

          <Image src='/img/logo.png' h="90px" objectFit="contain" />

          <Flex display={{ base: 'flex', md: 'auto' }} ml={10} align={'center'}>
            {!location.pathname.startsWith('/auth/') ? <DesktopNav /> : null}
          </Flex>
        </Flex>



        <Stack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          direction={'row'}
          spacing={6}>
          <UserMenu />
        </Stack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

let Label = ({ label }: { label: string }) => {
  let linkColor = useColorModeValue('gray.600', 'gray.200');
  let linkHoverColor = useColorModeValue('gray.800', 'white');
  return (
<Text
  p={2}
  fontSize={'lg'}
  fontWeight={500}
  color={linkColor}
  _hover={{
    textDecoration: 'none',
    color: linkHoverColor,
  }}>
  {label}
  </Text>)
}

let DesktopNav = () => {

  let popoverContentBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack direction={'row'} spacing={4}>
      {NAV_ITEMS.map((navItem, index) => (
        <Box key={navItem.label}>
          <Popover
            id={`pop-over-${index}`}
            trigger={'hover'} placement={'bottom-start'}
          >
            <PopoverTrigger>
              {
                navItem.href ? 
                (
                  <Link to={navItem.href}>
                    <Label label={navItem.label} />
                  </Link>
                ) : <a style={{ cursor: 'pointer'}}><Label label={navItem.label} /></a>
              }
             
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                id={`pop-over-content-${index}`}
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

let DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
  return (
    <Link to={href || '#'}>
      <Box
        role={'group'}
        display={'block'}
        p={2}
        rounded={'md'}
        _hover={{ bg: useColorModeValue('blue.50', 'gray.900') }}>
        <Stack direction={'row'} align={'center'}>
          <Box>
            <Text
              transition={'all .3s ease'}
              _groupHover={{ color: 'blue.400' }}
              fontWeight={500}>
              {label}
            </Text>
            <Text fontSize={'sm'}>{subLabel}</Text>
          </Box>
          <Flex
            transition={'all .3s ease'}
            transform={'translateX(-10px)'}
            opacity={0}
            _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
            justify={'flex-end'}
            align={'center'}
            flex={1}>
            {/* <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} /> */}
          </Flex>
        </Stack>
      </Box>
    </Link>
  );
};

let MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      p={4}
      display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
};

let MobileNavItem = ({ label, children, href }: NavItem) => {
  let { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Link to={href ?? '#'}>
        <Flex
          py={2}
          as={'div'}
          justify={'space-between'}
          align={'center'}
          _hover={{
            textDecoration: 'none',
          }}>
          <Text
            fontWeight={600}
            fontSize={"lg"}
            color={useColorModeValue('gray.600', 'gray.200')}>
            {label}
          </Text>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={'all .25s ease-in-out'}
              transform={isOpen ? 'rotate(180deg)' : ''}
              w={6}
              h={6}
            />
          )}
        </Flex>
      </Link>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Link key={child.label} to={child.href || '#'}>
                <Text py={2}>{child.label}</Text>
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
}

let NAV_ITEMS: Array<NavItem> = [
  /* {
    label: 'Elenco Utenti',
    children: [
      {
        label: 'Personale',
        href: '/users',
      },
      {
        label: 'Beneficiari',
        href: '/beneficiari',
      }
    ]
  }, */
  // {
  //   label: 'Gestione',
  //   href: '/work-dashboard',
  // },
  /* {
    label: 'Uffici',
    href: '/treeview-organizzazioni',
  }, */
  /* {
    label: 'Bandi',
    href: '/bandi'
    
  },*/
  {
    label: 'Reports',
    href: '/reports',
  },
  {
    label: 'Ticket',
    href: 'https://ticket.atpspcampania.it/',
  }
  /*{
    label: 'Manuali',
    href: '/help',
  }, 
  {
    label: 'Lavorazione Domande',
    href: '/istruttoria-domande',
  },*/

]
